/**
 * Gtag
 * Emmemedia - v0.8
 *
 * Le funzioni legate agli eventi
 *
 * Aggiornare i valori iniziali che cambiano ad ogni store
 *
 * Il tema può intervenire sul carrello sia con chiamate fetch che AJAX.
 * Per le chiamate fetch è necessario intervenire nel flusso originale,
 * mentre per le chiamate AJAX è necessario utilizzare direttamente jQuery.
 */

var origin = location.origin;

// Variabili da adattare al tema
var $quantitySelector = $('form[action="/cart/add"]').find('input[name=quantity]'); // Valore dell'input o select del tema
var $collectionProductSelector = $('.template-collection').find('.collection-page__product'); // Prodotto nella collection
var $formAddToCard = $('form.shopify-product-form');

function hrefProductInCollectionFinder($objClicked) {
  return $objClicked.find('.product-loop_title').find('a').attr('href'); // Url del prodotto nella collection
}

function hrefProductInCartFinder($objClicked) {
  return $objClicked.closest('.js-cart-items-container').find('a[href*="variant="]').attr('href'); // Url del prodotto nel carrello
}

function quantityCartBtnFinder($objClicked) {
  return parseInt($objClicked.closest('.js-cart-items-container').find('.quantity-wrapper input[name=quantity]').val()); // Quantità del prodotto (line) nel carrello
}



// Helpers
function handleFinder(str) {
  var urlFrom = 'products/';
  var strLength = urlFrom.length;
  return str.substring(str.indexOf(urlFrom) + strLength);
}

function handleVariantFinder(str) {
  var urlFrom = 'variant=';
  var strLength = urlFrom.length;
  return str.substring(str.indexOf(urlFrom) + strLength);
}

function getStringBetween(str, start, end) {
  return str.substring(
    str.lastIndexOf(start) + start.length,
    str.lastIndexOf(end)
  )
}



// Gestione per il detect di chiamate fetch o ajax a seconda del tema. Opzione anche per il submit del form

(function () {
  var originalFetch = fetch;
  fetch = function () {
    return originalFetch
      .apply(this, arguments)
      .then(async function (data) {

        switch (data.url) {
          case origin + '/cart/add' + '.js':
            data.clone().json().then(function (response) {
              sendAddToCart(response)
            })
            break;
          default:
        }

        return data;
      });
  };
})();

$(document).ajaxComplete(function( event, xhr, settings ) {
  if (settings.url.includes('cart/add')) {
    sendAddToCart(JSON.parse(xhr.responseText));
  }
});

$formAddToCard.on('submit', function() {

  var url = window.location.href;
  var handle = getStringBetween(url, 'products/', '?')
  var variantToSend = getStringBetween(url, 'variant=', '&')

  var quantityAdded = parseInt($quantitySelector.val());

  $.getJSON(window.Shopify.routes.root + `products/${handle}.js`, function (product) {
    product.variants.forEach(function (variant) {
      if (variant.id == variantToSend) {

        var productParsed = {
          product_title: product.title,
          item_variant: variant.title,
          id: product.id,
          price: (product.price/100),
          item_category: productCollection,
          product_type: product.product_type ? product.product_type : productCollection,
          item_list_id: "",
          quantity: quantityAdded,
          currency: cartCurrencyIso
        }

        sendAddToCart(productParsed)
      }
    })
  });
})



// Eventi
function sendAddToCart(product) {

  var quantityAdded = parseInt($quantitySelector.val());

  gtag("event", "add_to_cart", {
    items: [
      {
        item_name: product.product_title,
        item_variant: product.variant_title,
        item_id: product.id,
        price: (product.price/100),
        item_category: productCollection,
        item_list_name: product.product_type ? product.product_type : productCollection,
        item_list_id: "",
        quantity: quantityAdded,
        currency: cartCurrencyIso
      }
    ],
    currency: cartCurrencyIso,
    value: (quantityAdded * (product.price/100)).toFixed(2)
  })
  // console.log('Inviato gtag add_to_cart')

}

$(document).on('click', 'a[href*="cart/change"]', function() {
  if ($(this).attr('href').includes('quantity=0') && isPageCart) {

    var $this = $(this);
    var href = hrefProductInCartFinder($(this));
    var variantID = handleVariantFinder(href);
    var handleComplete = handleFinder(href);
    var handle = handleComplete.split("?")[0];

    $.getJSON(window.Shopify.routes.root + 'products/'+ handle +'.js', function(product) {

      $.each(product.variants, function(i, variant) {

        if (variantID == variant.id) {
          sendRemoveFromCart(product, variant, quantityCartBtnFinder($this));
          return false;
        }
      })
      // Trovare la variant corrispondente all'interno di product
      // Cicla le varianti e quando le trovi le salvi
    });

  }
});

function sendRemoveFromCart(product, variant, quantityDeleted) {

  gtag("event", "remove_from_cart", {
    currency: cartCurrencyIso,
    items: [
      {
        item_name: product.title,
        item_variant: variant.title,
        item_id: variant.id,
        price: (variant.price/100),
        item_category: "",
        item_list_id: "",
        quantity: quantityDeleted,
        currency: cartCurrencyIso
      }
    ]
  })
  // console.log('Inviato gtag remove_from_cart')

}

$collectionProductSelector.on('click', function(e) {

  var $this = hrefProductInCollectionFinder($(this));
  var index = $(this).index() + 1;
  var handle = handleFinder($this); // Url del prodotto cliccato in collection

  $.getJSON(window.Shopify.routes.root + 'products/'+ handle +'.js', function(product) {
    sendSelectItem(product, index)
  });
})

function sendSelectItem(product, index) {

  gtag("event", "select_item", {
    items: [
      {
        item_name: product.title,
        item_id: product.id,
        price: (product.price/100),
        item_category: productCollection,
        item_list_id: "",
        index: index,
        quantity: "1",
        currency: cartCurrencyIso
      }
    ]
  })
  // console.log('Inviato gtag select_item')

}
